import React, { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import PracticalQuestionsForm from "./PracticalQuestionsForm";
import { get, post } from "../../services/smartApiService";
import { showAlertAutoClose } from "../../services/notifyService";
import { PRACTICAL_URLS } from "../../api/AdminUrls";
import PracticalQuestionDetails from "./PracticalQuestionDetails";
import { checkInterSection } from "soft_digi/dist/services/FilterService";

const PracticalQuestions = () => {
  const { openModal, closeModal, setTitle,user } = useSiteContext();
  const [tabData, setTabData] = useState([]);
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN"]);

  const loadTableData = () => {
    let URL = PRACTICAL_URLS.GET_ALL;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
    setTitle(" Practical Questions");
  }, []);
  const openenterForm = (data: any) => {
    let options = {
      title: "Practical Questions Addition Form",
      content: (
        <PracticalQuestionsForm loadTableData={loadTableData} data={data} />
      ),
      width: 60,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };

  const deleteData = (id: any) => {
    const subscription = post(PRACTICAL_URLS.DELETE, { id: id }).subscribe(
      (response) => {
        showAlertAutoClose("Deleted Successfully...", "success");
        closeModal();
        loadTableData();
        // setLoading(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Practical Questions Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Practical Questions? This action
          cannot be reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const viewEditForm = (id: any) => {
    const subscription = post(PRACTICAL_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        response.data.start_time = "";
        response.data.end_time = "";
        openenterForm(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  const openViewdetails = (data: any) => {
    let options = {
      title: "Practical Questions Details",
      content: <PracticalQuestionDetails tableData={data} />,
      width: 60,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };
  const viewDetailsForm = (id: any) => {
    const subscription = post(PRACTICAL_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openViewdetails(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };
  const buttons = [
    //  {
    //    label: "",
    //    type: "icon",
    //    leftIcon: "fa fa-eye",
    //    classList: ["smart-hims-table-view-icon"],
    //    onClick: (data: any) => {
    //      viewDetailsForm(data["ID"]);
    //    },
    //  },
    {
      label: "",
      type: "icon",
      leftIcon: " fa-pencil-square",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => {
        viewEditForm(data["ID"]);
      },
        hideFunction: (data: any) => {
        return is_admin ? false : true;
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => {
        openDeleteModal(data["ID"]);
      },
        hideFunction: (data: any) => {
        return is_admin ? false : true;
      },
    },
  ];

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno" },
    {
      title: "Category",
      index: "category_name",
    },
    {
      title: "Title",
      index: "question_text",
    },
  
  ...(is_admin?[
      {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "15",
    },

  ]:[]as any)
  
  ];
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-7",
      custom: "",
      // custom: <p className="is-size-5">Practical Questionss</p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
        {
          label: "ADD",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: () => openenterForm({}),
        },
      ],
    },
  ];
    const UserTableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-7",
      custom: "",
      // custom: <p className="is-size-5">Practical Questionss</p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          type: "REFRESH",
          action: loadTableData,
        },
       
      ],
    },
  ];
  return (
    <>
      <div className="">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={is_admin? tableTop:UserTableTop}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          // paginationProps={{
          //   pageSize: 5,
          // }}
        />
      </div>
    </>
  );
};

export default PracticalQuestions;
